import { AppError } from '@/utils/api';
import { AuthenticatedHttp } from '../../http/axios';

export const createVideo = async ({ title, folderId }) => {
  try {
    const { data } = await AuthenticatedHttp.post(`/members/videos/`, {
      videoTitle: title,
      ...(folderId ? { folderId } : {}),
    });
    return data;
  } catch (error) {
    throw new AppError(error);
  }
};

export const deleteVideo = async ({ id }) => {
  try {
    await AuthenticatedHttp.delete(`/members/videos/${id}/`);
  } catch (error) {
    throw new AppError(error);
  }
};

export const getVideos = async ({ search, page }) =>
  AuthenticatedHttp.get(`/members/videos/`, {
    params: {
      search,
      limit: 5,
      page,
    },
  }).then(({ data }) => data);

export const getVideoById = async ({ id }) =>
  AuthenticatedHttp.get(`/members/videos/${id}/`).then((response) => response.data);
